import MdxContent from "../../help/quality-check-families.mdx";

export function QualityCheckFamiliesPageHelpPage() {
  return <MdxContent />;
}
